module.exports = __webpack_public_path__ + "media/applicants/facebook-1ee8f597.svg";